import { Component, OnInit } from '@angular/core';
import { ExamService } from 'src/app/services/Exam/exam.service';
import { Ng4LoadingSpinnerService } from 'ng4-loading-spinner';
import { LookupService } from 'src/app/services/Common/lookup.service';
import { GlobalHelper } from 'src/app/services/Common/global.service';
import * as moment from 'moment'

@Component({
  selector: 'app-class-term-map',
  templateUrl: './class-term-map.component.html',
  styleUrls: ['./class-term-map.component.css']
})
export class ClassTermMapComponent implements OnInit {
  Submitted:boolean= false;
  ClassTermMapList:any;
  GradeList:any;

  constructor(private examservice:ExamService,private LookupService: LookupService, private globalHelper: GlobalHelper, 
    private spinnerService: Ng4LoadingSpinnerService) { }

    ClassTermMapModel = {
      ClassID: 0,
      IsMandatory: false,
      IsActive: false
  }

  SaveClassTermMap(valid) {
    
  
    this.Submitted = true;
    if (valid) {
      this.spinnerService.show();
      for (var i = 0; i < this.ClassTermMapList.length; i++) {
        if (this.ClassTermMapList[i].IsActive && this.ClassTermMapList[i].StartDate != null && this.ClassTermMapList[i].StartDate != '') {
          this.ClassTermMapList[i].StartDate = moment(this.ClassTermMapList[i].StartDate).format('DD-MMM-YYYY');
        }
        if (this.ClassTermMapList[i].IsActive && this.ClassTermMapList[i].EndDate != null && this.ClassTermMapList[i].EndDate != '') {
          this.ClassTermMapList[i].EndDate = moment(this.ClassTermMapList[i].EndDate).format('DD-MMM-YYYY');
        }
      }
      this.examservice.SaveClassTermMap(JSON.stringify(this.ClassTermMapList),this.ClassTermMapModel.ClassID).subscribe((data: any) => {
        if (data.webResponse.Status) {
          this.GetClassTermMap();
        }
        if (data.webResponse.Status && this.ClassTermMapModel.ClassID == 0) {
        
          this.GetClassTermMap();
        }
        this.globalHelper.CheckActionStatus(data);
        this.spinnerService.hide();
      });
    }
  
  };

  GetClassTermMap(){
        
    this.spinnerService.show();
    this.examservice.GetClassTermMap(this.ClassTermMapModel.ClassID).subscribe((data: any) => {
    this.ClassTermMapList = data.ClassTermMapList;
    this.globalHelper.CheckActionStatus(data);
    this.spinnerService.hide();
   
});
};

GetClass() {

  this.LookupService.GetLookupsList('Class', '').subscribe((data: any) => {
    this.GradeList = data.LookupItems;
  });

}
  ngOnInit() {
    this.GetClass();
  }

}
